import { createStateHook, createNextHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useTrainersState = createStateHook(
  AppStoreProvider,
  state => state.pages.trainers
)
export const useNextTrainersState = () =>
  createNextHook(AppStoreProvider, state => state.pages.trainers)
